import { BackgroundTransactionData } from "@/app/background-transactions";

export const isTransactionPending = (tx: BackgroundTransactionData) =>
  tx.status === "sending" || tx.status === "confirming";
